const RewardDestinations: any = {
  ACCOUNT: 'Account',
  FEE_REDUCTION: 'Fee Reduction',
};

export default RewardDestinations;
